import type { RootState } from '@/store/root-reducer';

const selectSchoolsState = (state: RootState) => state.schools;

export const selectRows = (state: RootState) => selectSchoolsState(state).rows;
export const selectTotal = (state: RootState) => selectSchoolsState(state).total;
export const selectLoading = (state: RootState) => selectSchoolsState(state).loading;
export const selectError = (state: RootState) => selectSchoolsState(state).error;
export const selectPage = (state: RootState) => selectSchoolsState(state).page;
export const selectPageSize = (state: RootState) => selectSchoolsState(state).pageSize;
